import { defineNuxtPlugin } from '#app';

// This plugin ensures that Mosaico is only loaded on the client side
export default defineNuxtPlugin(async (nuxtApp) => {
  // We won't actually import Mosaico here since it will be loaded via iframe
  // But we'll provide a flag to indicate availability
  
  if (process.client) {
    try {
      console.log('Mosaico plugin registered for client-side use');
    } catch (error) {
      console.error('Failed to initialize Mosaico:', error);
    }
  }
  
  return {
    provide: {
      isMosaicoAvailable: process.client
    }
  };
}); 